import React, { useEffect, useMemo } from "react";
import { Tag, TagsInput } from "@cadmakers-ui/core";
import { useHistory } from "react-router";
import { useTags } from "..";
import styles from "../Styles/TagDisplay.module.scss";
import { appPaths } from "../../Common";

type Props = {
  selectedIds: number[];
};

const TagDisplay: React.FC<Props> = props => {
  const tags = useTags();
  const history = useHistory();

  const selectedTags = useMemo(() => {
    if (!tags.loadingState.isLoaded) {
      return [];
    }

    return tags.tags.filter(t => props.selectedIds.includes(t.id));
  }, [tags, props.selectedIds]);

  const onClickTag = (e: React.MouseEvent, id: number) => {
    const route = appPaths.tags.details.replace(":tagId", id.toString());
    history.push(route);

    e.stopPropagation();
  };

  return (
    <>
      {selectedTags.map(t => (
        <Tag
          color={t.color}
          translate={{}}
          className={styles.tag}
          onClick={e => onClickTag(e, t.id)}
        >
          {t.name}
        </Tag>
      ))}
    </>
  );
};

export default TagDisplay;
